import { useContext, useState } from "react";
import TableComponent from "./InitiativeTracker/TableComponent";
import { RowObject } from "../Types/TableTypes";
import HeaderButtonsComponent from "./InitiativeTracker/HeaderButtonsComponent";
import AllSpellsProvider from "../Context/AllSpellsContext";
import AllMonstersProvider from "../Context/AllMonstersContext";
import "../InitiativeTracker.css"
import { EditModeContext } from "../Context/EditModeContext";
interface InitiativeTrackerComponentProps {}

const InitiativeTrackerComponent = (props: InitiativeTrackerComponentProps)=>{
    
    const [creatures, setCreatures] = useState([] as RowObject[]);
    const [currentTurn, setCurrentTurn] = useState(0);
    const {editMode, setEditMode} = useContext(EditModeContext);
    
    return (
        <div 
            // style={{margin: "40px"}}
        >
            <AllMonstersProvider>
                <AllSpellsProvider>
                    <HeaderButtonsComponent
                        // round={round}
                        currentTurn={currentTurn}
                        editMode={editMode}
                        creatures={creatures}
                        setCreatures={setCreatures}
                        setCurrentTurn={setCurrentTurn}
                        setEditMode={setEditMode!}
                    ></HeaderButtonsComponent>
                    <TableComponent
                        creatures={creatures}
                        setCreatures={setCreatures}
                        currentTurn={currentTurn}
                        editMode={editMode}
                    ></TableComponent>
                </AllSpellsProvider>
            </AllMonstersProvider>
        </div>
    )
}
export default InitiativeTrackerComponent;